import { ModalContainer, ModalBox, CloseButton } from './styles'

const DefaultModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <ModalContainer onClick={onClose}>
      <ModalBox onClick={(e) => e.stopPropagation()}>
        <CloseButton type="button" onClick={onClose} aria-label="Fechar">×</CloseButton>
        {children}
      </ModalBox>
    </ModalContainer>
  );
};

export default DefaultModal;